// @flow

import * as React from 'react';
import { connect } from 'react-redux';

import { localize } from '@ta/common.i18n';
import type { ViewportCategory } from '@ta/common.state';
import { DeprecatedModalLink } from '@ta/overlays.modal';
import { InteractionLogger } from '@ta/tracking.interactions';
import type { SuggestedFolloweesPlacementInput } from '@ta/social.member-types';

import SuggestedMembersModal from './SuggestedMembersModal';

import styles from './SuggestedMembersModalCombined.less';

type ExternalProps = {
  username: ?string,
  placement?: SuggestedFolloweesPlacementInput,
  seeMoreLink?: boolean,
};

type Props = {
  ...ExternalProps,
  viewportCategory: ViewportCategory,
  loggedInUserId: string,
  /* True if site is in read-only mode.  Disables popup. */
  readOnly: boolean,
};

type State = {
  currentFlow: number,
};

const FLOW_USER_INITIATED = 0;
const FLOW_AUTO_POPUP = 1;

class SuggestedMembersModalCombined extends React.Component<Props, State> {
  static defaultProps = {
    placement: undefined,
    username: null,
    seeMoreLink: true,
  };

  constructor(props: Props) {
    super(props);
    this.state = {
      currentFlow: 0,
    };
  }

  render() {
    const { username, placement, seeMoreLink, loggedInUserId } = this.props;

    const seeMore = seeMoreLink ? styles.show_more : '';

    const getTitleText = () => {
      switch (this.state.currentFlow) {
        case FLOW_AUTO_POPUP:
          /** Now you can follow trusted experts on TripAdvisor for amazing travel ideas + advice */
          return localize('Follow_modal_update_home_1217');

        default:
          /** Discover travel ideas + advice from these trusted experts */
          return localize('Follow_modal_update_1217');
      }
    };

    const getModalLinkProps = (name, className, loggingFunction) => {
      const modalLinkProps: any = {
        name,
        href: null,
        onClick: e => {
          this.setState({
            currentFlow: FLOW_USER_INITIATED,
          });
          if (loggingFunction) {
            loggingFunction(e, 'rightRailSeeMoreClick');
          }
        },
      };
      if (username) {
        modalLinkProps.username = username;
      }
      if (className) {
        modalLinkProps.className = className;
      }
      return modalLinkProps;
    };

    return (
      <React.Fragment>
        <InteractionLogger>
          {loggingFunction => (
            <DeprecatedModalLink
              {...getModalLinkProps('suggested_members', seeMore, loggingFunction)}
            >
              {seeMoreLink && (
                <span className="ui_link">
                  {/* See more */}
                  {localize('followee_shelf_see_more')}
                </span>
              )}
            </DeprecatedModalLink>
          )}
        </InteractionLogger>
        <SuggestedMembersModal
          title={getTitleText()}
          type="TripAdvisor"
          modalName="suggested_members"
          placement={placement}
          showFacebookTab={loggedInUserId !== null}
        />
        {/* Necessary for FB connections to be triggered from a direct link - queried only at request time */}
        <DeprecatedModalLink {...getModalLinkProps('suggested_facebook_connections')} />
        <SuggestedMembersModal
          title={getTitleText()}
          type="Facebook"
          modalName="suggested_facebook_connections"
          placement={placement}
        />
      </React.Fragment>
    );
  }
}

export default connect<Props, ExternalProps, _, _, _, _>(state => ({
  loggedInUserId: state.auth.loggedInUserId,
  readOnly: state.meta.readonlyMode,
  viewportCategory: state.meta.device.viewportCategory,
}))(SuggestedMembersModalCombined);
